








































import { defineComponent } from '@vue/composition-api';
import type { PropType } from 'vue';
import LobbyCard from '../../lobby/components/LobbyCard.vue';
import Consent from '../../lobby/components/Consent.vue';
import type { VerifyLinkResponse } from '../../api/universal-link/types/verify-link-response';
import { useIdentifyRecipient } from './composables/identify-recipient.composable';

export default defineComponent({
  name: 'IdentifyRecipientModal',
  components: {
    Consent,
    LobbyCard,
  },
  props: {
    verifyLinkResponse: {
      type: Object as PropType<VerifyLinkResponse>,
      required: true,
    },
  },

  setup(props) {
    const {
      loadingRedirectURL,
      submitDisabled,
      submit,
      helpMessage,
      emailInvalid,
      errorMessage,
      recipient,
      consentGiven,
      setConsent,
      consentStep,
    } = useIdentifyRecipient(props.verifyLinkResponse);

    return {
      loadingRedirectURL,
      submitDisabled,
      submit,
      helpMessage,
      emailInvalid,
      errorMessage,
      recipient,
      consentGiven,
      setConsent,
      consentStep,
    };
  },
});
